import {LinkedEntity} from 'shells/linked-entity/linked-entity';

import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import type {RelatedEntity} from './types';

interface Props {
    status: string;
    assignee: RelatedEntity | null | undefined;
    relatedAccount: RelatedEntity | null | undefined;
    relatedContact: RelatedEntity | null | undefined;
    value: string | null | undefined;
}

export function LeadRowContent(props: Props) {
    return (
        <Stack spacing={2}>
            {props.value && (
                <Body size='small' color='medium'>
                    {props.value}
                </Body>
            )}
            {props.assignee && (
                <Body size='small' color='medium' title='Assignee'>
                    {props.assignee.name}
                </Body>
            )}
            {props.relatedAccount && (
                <LinkedEntity
                    name={props.relatedAccount.name}
                    type='accounts'
                    htmlUrl={props.relatedAccount.htmlUrl}
                />
            )}
            {props.relatedContact && (
                <LinkedEntity
                    name={props.relatedContact.name}
                    type='contacts'
                    htmlUrl={props.relatedContact.htmlUrl}
                />
            )}
        </Stack>
    );
}
